import Utils from '../utils/utils';
import {errorHandler} from '../utils/errorHandler';

function handleErrorMessage(payload) {
  const message = Utils.isDevEnv() ? `${payload.errorCode}::: ${payload?.message}` : errorHandler.getErrorMessage(payload.errorCode);
  return message;
}

export default handleErrorMessage;